export default __webpack_public_path__ + "static/media/MTV01.17137c4c.png";